import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
// import Backend from 'i18next-locize-backend'
import Backend from 'i18next-http-backend'
import translationEN from './locales/en/translation.json'
import translationEL from './locales/el/translation.json'
import translationDE from './locales/de/translation.json'
import translationFR from './locales/fr/translation.json'
import translationTR from './locales/tr/translation.json'
import translationBG from './locales/bg/translation.json'
import translationSR from './locales/sr/translation.json'
import translationRO from './locales/ro/translation.json'

i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(Backend)
    .init({
        deguf: true,
        fallbackLng: 'en',
        lng: 'el',
        saveMissing: true,
        resources: {
            en: {
                translation: translationEN
            },
            el: {
                translation: translationEL
            },
            de: {
                translation: translationDE
            },
            fr: {
                translation: translationFR
            },
            tr: {
                translation: translationTR
            },
            bg: {
                translation: translationBG
            },
            sr: {
                translation: translationSR
            },
            ro: {
                translation: translationRO
            },
        }
        // locize backend
        // backend: {
        //     projectId: '45df07ba-601a-4a3c-b456-6b3b61a1e03e',
        //     apiKey: 'e4ee328d-768a-4388-acd3-3ae84e0acfc7'
        // }
    })

export default i18next